import { Link } from 'react-router-dom';
import ArticleCard from '@/components/feature/ArticleCard';
import SectionHeading from '@/components/feature/SectionHeading';
import { articles } from '@/mocks/gossip';

export default function FocusSection() {
  const [lead, ...rest] = articles;
  const sideItems = rest.slice(0, 4);

  return (
    <section className="mx-auto max-w-[1240px] px-4 pt-16 md:px-8 md:pt-20">
      <SectionHeading
        eyebrow="今日焦点"
        title="红毯与同框的高光正在发生"
        description="编辑团队按活动场次整理，把最有画面感的那几组放到最前面。"
        action={
          <Link
            to="/category/all"
            className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看全部图集
            <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
          </Link>
        }
      />

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <ArticleCard article={lead} variant="overlay" />
        </div>
        <div className="flex flex-col justify-between gap-4 lg:col-span-5">
          {sideItems.map((item) => (
            <ArticleCard key={item.id} article={item} variant="row" />
          ))}
        </div>
      </div>
    </section>
  );
}